export class Tag {
  id: number = 0;
  text: string = '';
  categoryId: number = 0;

  public static createFromJson(input: any): Tag {
    const data = new Tag();
    data.fromJson(input);
    return data;
  }

  fromJson(input: any) {
    this.id = input["id"];
    this.text = input["text"];
    this.categoryId = input["categoryId"];
  }

  toJson(): any {
    return {
      id: this.id,
      text: this.text,
      categoryId: this.categoryId
    };
  }
}
